import { render } from 'preact';
import { App } from './app';
import { startTheme } from './lib/theme';
import { RegisterApp } from './register-app';
import './styles/fonts.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/shell.css';

const root = document.getElementById('app');
// The supplier form is public: it gets its own shell and never starts Microsoft sign-in.
const isRegister = location.hash.startsWith('#/register');
// Staff only, before the first render so a dark theme never flashes light. The supplier form
// stays light: it has no switch.
if (!isRegister) startTheme();
if (root) render(isRegister ? <RegisterApp /> : <App />, root);
